module.exports = __webpack_public_path__ + "static/media/exp-bg.9981acae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/exp-bg.jpg
// module id = 299
// module chunks = 0